const obj = {
  id: '',
  organizationId: '',
  organizationName: '',
  eventId: '',
  scheduleId: '',
  eventName: '',
  scheduleName: '',
  startDate: '',
  endDate: '',
  isAdminPlus: false,
}

export default function StandModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
